module.exports = __webpack_public_path__ + "static/img/walkway-straight_256.df2fd4f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/walkway-straight_256.png
// module id = uf4J
// module chunks = 0